import { render, staticRenderFns } from "./AccidentPolicyInfo.vue?vue&type=template&id=11bfa01b&"
import script from "./AccidentPolicyInfo.vue?vue&type=script&lang=js&"
export * from "./AccidentPolicyInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports